
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import PropTypes from 'prop-types';

function LiveGameStatsTable (props) {
    return Template.default.apply({props}); //eslint-disable-line no-undef
}

LiveGameStatsTable.propTypes = {
    stats: PropTypes.object.isRequired,
    sportAlias: PropTypes.string.isRequired,
    team1_name: PropTypes.string.isRequired,
    team2_name: PropTypes.string.isRequired,
    isItf: PropTypes.bool
};

export default LiveGameStatsTable;